export default __webpack_public_path__ + "static/download-vertical-0a2914255bd07ce09436dd06c5a1f712.jpg";